import React, { useEffect, useState } from 'react';
import { Button, Typography, Box } from '@mui/material';
import { useAppContext } from '../../contexts/AppContext';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import { useNavigate } from 'react-router';
import { buildProductPath } from '../../utils/seo';

export default function CartButtons(props) {
  const { product, redirectToDetails = false } = props;
  const navigate = useNavigate();

  const { addToCart, decreaseFromCart, cartItems } = useAppContext();
  const [isAdding, setIsAdding] = useState(false);
  const item =
    cartItems.length > 0 && cartItems.find((cartItem) => cartItem.id === product.id);
  const quantity = item ? item.quantity : 0;

  useEffect(() => {
    if (!isAdding) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setIsAdding(false);
    }, 360);

    return () => window.clearTimeout(timeoutId);
  }, [isAdding]);

  if (redirectToDetails) {
    return (
      <Button
        variant='contained'
        className='app-pressable'
        sx={{
          fontWeight: '600',
          fontSize: '1.1rem',
          borderRadius: 2.5,
          minWidth: 36,
          width: 36,
          height: 36,
          padding: 0,
          lineHeight: 1.3,
          boxShadow: 'none',
        }}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          navigate(buildProductPath(product));
        }}
      >
        <LocalMallIcon fontSize='small' />
      </Button>
    );
  }

  if (quantity === 0) {
    return (
      <Button
        variant='contained'
        className={`app-pressable app-cartAction${isAdding ? ' app-cartAction--active' : ''}`}
        sx={{
          fontWeight: '600',
          fontSize: '1.1rem',
          borderRadius: 2.5,
          minWidth: 36,
          width: 36,
          height: 36,
          padding: 0,
          lineHeight: 1.3,
          boxShadow: 'none',
        }}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setIsAdding(true);
          addToCart(product);
        }}
      >
        <LocalMallIcon fontSize='small' />
      </Button>
    );
  }

  return (
    <Box
      className={isAdding ? 'app-cartAction app-cartAction--active' : 'app-cartAction'}
      style={{
        display: 'flex',
        gap: 8,
        alignItems: 'center',
      }}
    >
      <Button
        variant='contained'
        className='app-pressable'
        sx={{
          fontWeight: '600',
          fontSize: '1.1rem',
          borderRadius: 2.5,
          minWidth: 28,
          width: 28,
          height: 28,
          padding: 0,
          lineHeight: 1.3,
          boxShadow: 'none',
        }}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          decreaseFromCart(product.id);
        }}
      >
        -
      </Button>

      <Typography
        variant='subtitle1'
        noWrap
        sx={{ fontWeight: '700', fontSize: '0.88rem', minWidth: 10, textAlign: 'center' }}
      >
        {quantity}
      </Typography>
      <Button
        variant='contained'
        size='medium'
        className='app-pressable'
        sx={{
          fontWeight: '600',
          fontSize: '1.1rem',
          borderRadius: 2.5,
          minWidth: 28,
          width: 28,
          height: 28,
          padding: 0,
          lineHeight: 1.3,
          boxShadow: 'none',
        }}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setIsAdding(true);
          addToCart(product);
        }}
      >
        +
      </Button>
    </Box>
  );
}
